export default "__VITE_ASSET__CKww7bxd__"